import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LegadoPage from '../pages/LegadoPage';
import LoginPage from '../pages/LoginPage';
import ProductsPage from '../pages/ProductsPage';

export const PATHS = {
  root: '/',
  login: '/login',
  apis: '/apis',
  legado: '/legado',
};

function Routes() {
  return (
    <Switch>
      <Route path={PATHS.root} exact>
        <LoginPage />
      </Route>

      <Route path={PATHS.login} exact>
        <LoginPage />
      </Route>

      <Route path={PATHS.apis}>
        <ProductsPage />
      </Route>

      <Route path={PATHS.legado}>
        <LegadoPage />
      </Route>
    </Switch>
  );
}

export default Routes;
